//src/store/actions/claimaatachment.action.ts
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ClaimAttachment, Note } from '@dataTypes/claimManagement.types'
import claimsData from '@assets/mockdata/Claims/claimsData'

export const fetchAllClaimAttachments = createAsyncThunk(
  'api/claimattachment/fetch/all',
  async ({ claimId }: { claimId: string }, { rejectWithValue }) => {
    try {
      if (!claimId) return rejectWithValue('Claim ID is required')

      const claim = claimsData.find((c) => c.id === claimId)
      const mockAttachments = claim ? claim.attachments : []

      return { claimId, attachments: mockAttachments }
    } catch (error: any) {
      return rejectWithValue('Failed to fetch claim attachments')
    }
  },
)

export const addClaimAttachment = createAsyncThunk(
  'api/claimattachment/add',
  async (attachment: ClaimAttachment) => {
    return attachment
  },
)

export const updateClaimAttachment = createAsyncThunk(
  'api/claimattachment/update',
  async ({
    claimId,
    itemNo,
    updatedAttachment,
  }: {
    claimId: string
    itemNo: number
    updatedAttachment: Partial<ClaimAttachment>
  }) => {
    return { claimId, itemNo, updatedAttachment }
  },
)

export const deleteClaimAttachment = createAsyncThunk(
  'api/claimattachment/delete',
  async ({ claimId, itemNo }: { claimId: string; itemNo: number }) => {
    return { claimId, itemNo }
  },
)

export const fetchAllClaimNotes = createAsyncThunk(
  'api/claimnote/fetch/all',
  async ({ claimId }: { claimId: string }, { rejectWithValue }) => {
    try {
      if (!claimId) return rejectWithValue('Claim ID is required')
      return { claimId }
    } catch (error: any) {
      return rejectWithValue('Failed to fetch claim notes')
    }
  },
)

export const addClaimNote = createAsyncThunk(
  'api/claimnote/add',
  async ({ claimId, note }: { claimId: string; note: Note }) => {
    return { claimId, note }
  },
)

export const updateClaimNote = createAsyncThunk(
  'api/claimnote/update',
  async ({
    claimId,
    itemNo,
    index,
    updatedNote,
  }: {
    claimId: string
    itemNo: number
    index: number
    updatedNote: Partial<Note>
  }) => {
    return { claimId, itemNo, index, updatedNote }
  },
)

export const deleteClaimNote = createAsyncThunk(
  'api/claimnote/delete',
  async ({ claimId, index }: { claimId: string; index: number }) => {
    return { claimId, index }
  },
)
